import { Well } from '@/components/Elements';
import { ContentLayout } from '@/components/Layout';
import { PageHeading } from '@/components/Layout/PageHeading';

import { Paystubs } from '../components/Paystubs';

const title = 'Payments';

export const Payments = () => (
  <ContentLayout title={title}>
    <Well>
      <>
        <PageHeading title={title} />
        <Paystubs />
      </>
    </Well>
  </ContentLayout>
);
